<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div>
        <el-button type="text" @click="$router.push('/platform')"
          >人才币规则</el-button
        >
        <el-button type="primary">代理规则</el-button>
        <el-button type="text" @click="$router.push('/fee')">会员</el-button>
        <el-button type="text" @click="$router.push('/rules')"
          >就业补贴</el-button
        >
        <el-button type="text" @click="$router.push('/companyrules')"
          >企业邀请规则</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <div class="section shadow" style="padding: 10px 50px">
        <el-form
          ref="elFormDom"
          label-width="140px"
          label-position="right"
          :model="form.data"
          :rules="form.rules"
        >
          <el-row :gutter="40">
            <el-col :span="24">
              <h4>
                一、新用户简历被下载奖励
                <el-tooltip placement="right">
                  <div slot="content">
                    1、企业下载代理商所代理学校的用户简历，代理可获得企业所消耗人才币的对应比例作为奖励，具体以学校代理佣金比例设置为准<br />2、企业下载代理拉新的用户，代理可获得企业所消耗人才币的对应比例作为奖励，具体以拉新代理佣金比例设置为准<br />3、代理商为用户端的校园HR主管，所获人才币满100可申请提现，折算10人才币=1元
                  </div>
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </h4>
              <p>企业下载简历消耗的人才币分成比例：</p>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="school_rate" label="学校代理比例">
                <el-input
                  type="age"
                  v-model.number="form.data.school_rate"
                  placeholder="请输入比例"
                >
                  <span slot="suffix">%</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="agent_rate" label="拉新代理比例">
                <el-input
                  type="age"
                  v-model.number="form.data.agent_rate"
                  placeholder="请输入比例"
                >
                  <span slot="suffix">%</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="auth_user_rate" label="认证用户比例">
                <el-input
                  type="age"
                  v-model.number="form.data.auth_user_rate"
                  placeholder="请输入比例"
                >
                  <span slot="suffix">%</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <p>企业查看简历消耗的人才币分成比例：</p>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="school_read_rate" label="学校代理比例">
                <el-input
                  type="age"
                  v-model.number="form.data.school_read_rate"
                  placeholder="请输入比例"
                >
                  <span slot="suffix">%</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="agent_read_rate" label="拉新代理比例">
                <el-input
                  type="age"
                  v-model.number="form.data.agent_read_rate"
                  placeholder="请输入比例"
                >
                  <span slot="suffix">%</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="auth_user_read_rate" label="认证用户">
                <el-input
                  type="age"
                  v-model.number="form.data.auth_user_read_rate"
                  placeholder="请输入比例"
                >
                  <span slot="suffix">%</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <h4>
                二、代理邀请会员成功入职奖励
                <el-tooltip placement="right">
                  <div slot="content">
                    企业每招聘成功1人系统收取500元服务费，若被招聘人员为代理邀请的用户，对应代理可获得奖励分成
                  </div>
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </h4>
              <p>企业招聘服务费代理可获得以下分成：</p>
            </el-col>
            <el-col :span="8">
              <el-form-item
                prop="agent_invite_entry_rate"
                label="代理分成"
                label-width="80px"
              >
                <el-input
                  type="age"
                  v-model.number="form.data.agent_invite_entry_rate"
                  placeholder="请输入代理分成"
                >
                  <span slot="suffix">%</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <h4>
                三、代理邀请用户开通会员奖励
                <el-tooltip placement="right">
                  <div slot="content">
                    有代理的用户缴纳会员费，会员费给与代理的奖励比例
                  </div>
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </h4>
              <p>用户缴纳的会员费代理可以获得以下分成：</p>
            </el-col>
            <el-col :span="8">
              <el-form-item
                prop="agent_invite_vip_rate"
                label="代理分成"
                label-width="80px"
              >
                <el-input
                  type="age"
                  v-model.number="form.data.agent_invite_vip_rate"
                  placeholder="请输入代理分成"
                >
                  <span slot="suffix">%</span>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="section shadow" style="padding: 20px; margin-top: 40px">
        <el-row type="flex" justify="center">
          <el-button @click="reset">重置</el-button>
          <el-button
            type="primary"
            :loading="form.loading"
            :disabled="form.loading"
            @click="confirm"
            >确定</el-button
          >
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
export default {
  name: "AgentList",
  components: {
    VTable,
  },
  data() {
    return {
      form: {
        loading: false,
        data: {
          school_rate:'',
          agent_rate:'',
          auth_user_rate:'',
          school_read_rate:'',
          agent_read_rate:'',
          auth_user_read_rate:'',
          agent_invite_entry_rate:'',
          agent_invite_vip_rate:''
        },
        rules: {
          school_rate: [
            { required: true, message: "佣金比例不能为空" },
            { type: "number", message: "佣金比例只能输入整数" },
          ],
          agent_rate: [
            { required: true, message: "佣金比例不能为空" },
            { type: "number", message: "佣金比例只能输入整数" },
          ],
          auth_user_rate: [
            { required: true, message: "佣金比例不能为空" },
            { type: "number", message: "佣金比例只能输入整数" },
          ],
          school_read_rate: [
            { required: true, message: "佣金比例不能为空" },
            { type: "number", message: "佣金比例只能输入整数" },
          ],
          agent_read_rate: [
            { required: true, message: "佣金比例不能为空" },
            { type: "number", message: "佣金比例只能输入整数" },
          ],
          auth_user_read_rate: [
            { required: true, message: "佣金比例不能为空" },
            { type: "number", message: "佣金比例只能输入整数" },
          ],
          agent_invite_vip_rate: [
            { required: true, message: "代理分成不能为空" },
            { type: "number", message: "代理分成只能输入整数" },
          ],
          agent_invite_entry_rate: [
            { required: true, message: "代理分成不能为空" },
            { type: "number", message: "代理分成只能输入整数" },
          ],
        },
      },
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http.get("admin/rule/getRate", { params: {} }).then((res) => {
        if (res.code === 1) {
          let info = res.data;
          Object.keys(info).forEach((key) => {
            this.form.data[key] = Number(info[key]);
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          this.$http
            .post("admin/rule/setRate", this.form.data)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("设置比例成功");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    reset() {
      this.$refs.elFormDom.resetFields();
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
</style>